import { HashClaim } from 'api'
import { validateEmail, validateEthAdresses } from 'lib/utils'
import { trackGACustomEvent } from '../common'
import { ADDRESS_INPUT_TRACKING, GA_TRACK_CATEGORY } from '../constants'
import { IClaim } from '../interfaces/analyticsInterfaces'

enum ClaimActions {
  EVENT_CLAIM_REQUEST_TRANSACTION = 'requested_claim_transaction',
  EVENT_CLAIM_ACCEPTED_TRANSACTION = 'accepted_claim_transaction',
  EVENT_CLAIM_ERROR_TRANSACTION = 'error_claim_transaction',
  EVENT_CLAIM_SUCCESS = 'success_claim',
  EVENT_CLAIM_SHOW_BANNER = 'show_banner',
  EVENT_CLAIM_CLOSE_BANNER = 'close_banner',
  EVENT_CLAIM_CLICK_BTN_BANNER = 'click_btn_banner',
  EVENT_CLAIM_CLICK_BTN_APP_STORE = 'click_btn_app_store',
  EVENT_CLAIM_CLICK_BTN_PLAY_STORE = 'click_btn_play_store',
  EVENT_CLAIM_VIEW_IN_GALLERY = 'view_in_gallery',
  EVENT_CLAIM_VIEW_COLLECTION = 'view_collection',
}

export const Claim: IClaim = {
  trackRequestTransaction: (claim: HashClaim) => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.CLAIM,
      action: ClaimActions.EVENT_CLAIM_REQUEST_TRANSACTION,
    })
  },

  trackAcceptedTransaction: (claim: HashClaim) => {
    const address: string = claim.qr_hash.toLowerCase()
    let addressType = ADDRESS_INPUT_TRACKING.ENS_NAME

    if (validateEmail(address)) {
      addressType = ADDRESS_INPUT_TRACKING.EMAIL
    } else if (validateEthAdresses(address)) {
      addressType = ADDRESS_INPUT_TRACKING.ETH_ADDRESS
    }

    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.CLAIM,
      action: `${ClaimActions.EVENT_CLAIM_ACCEPTED_TRANSACTION}__${addressType}`,
    })
  },

  trackSuccessClaim: () => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.CLAIM,
      action: ClaimActions.EVENT_CLAIM_SUCCESS,
    })
  },

  trackUnsuccessfulRequestTransaction: (error: Error, claim?: HashClaim) => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.CLAIM,
      action: ClaimActions.EVENT_CLAIM_ERROR_TRANSACTION,
    })
  },

  trackViewASmartBanner: () => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.CLAIM,
      action: ClaimActions.EVENT_CLAIM_SHOW_BANNER,
    })
  },

  trackCloseSmartBanner: () => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.CLAIM,
      action: ClaimActions.EVENT_CLAIM_CLOSE_BANNER,
    })
  },

  trackClickBtnASmartBanner: () => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.CLAIM,
      action: ClaimActions.EVENT_CLAIM_CLICK_BTN_BANNER,
    })
  },

  trackClickBtnAppStore: () => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.CLAIM,
      action: ClaimActions.EVENT_CLAIM_CLICK_BTN_APP_STORE,
    })
  },

  trackClickBtnPlayStore: () => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.CLAIM,
      action: ClaimActions.EVENT_CLAIM_CLICK_BTN_PLAY_STORE,
    })
  },

  trackViewInGallery: () => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.CLAIM,
      action: ClaimActions.EVENT_CLAIM_VIEW_IN_GALLERY,
    })
  },

  trackViewCollection: () => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.CLAIM,
      action: ClaimActions.EVENT_CLAIM_VIEW_COLLECTION,
    })
  },
}
